export const PLANNING_COMMENTS_WIDGET_NAMESPACE = 'widget.planning-comments'
